import { ITouristGroup } from '../model/ITourIstGroup';

export default function (touristGroup: ITouristGroup | undefined): boolean {
    if (!touristGroup) return false;
    return !!(touristGroup.infants || touristGroup.kids);
}